import { render, staticRenderFns } from "./DeliveryOptionMappingView.vue?vue&type=template&id=3650e4d6&scoped=true"
import script from "./DeliveryOptionMappingView.vue?vue&type=script&lang=js"
export * from "./DeliveryOptionMappingView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryOptionMappingView.vue?vue&type=style&index=0&id=3650e4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3650e4d6",
  null
  
)

export default component.exports